module.exports = __webpack_public_path__ + "static/img/5.5274530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/5.png
// module id = tHRy
// module chunks = 0